import { Checkbox, Col, Form, Input, InputNumber, Row, Select, Typography } from "antd";
import { useIntl } from "react-intl";
import { createMaxPlayersValidator } from "~Features/MatchProfiles/shared/maxPlayersValidator";
import {MatchProfileNumberFormInput} from "~Features/MatchProfiles/shared/MatchProfileNumberFormInput";

const checkboxOptions = [
  { value: 1, label: "P1" },
  { value: 2, label: "P2" },
  { value: 3, label: "P3" },
  { value: 4, label: "P4" },
  { value: 11, label: "OT1" },
  { value: 12, label: "OT2" },
  { value: 13, label: "OT3" },
  { value: 14, label: "OT4" },
  { value: 15, label: "OT5" },
  { value: 16, label: "OT6" },
];

const typeOfCards = [
  { value: "Blue", label: "Blue Card" },
  { value: "Yellow", label: "Yellow Card" },
  { value: "Red", label: "Red Card" },
];

const HandballForm = () => {
  const { formatMessage } = useIntl();

  return (
    <>
      <Row>
        <Col span={6}>
          <Form.Item
            labelCol={{ span: 7 }}
            wrapperCol={{ span: 16 }}
            required={true}
            name={"name"}
            rules={[
              {
                required: true,
                message: "Please input name",
              },
            ]}
            label={formatMessage({
              id: "name",
              defaulMessage: "Name",
            })}
          >
            <Input />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item
            name={"defaultProfile"}
            label={formatMessage({
              id: "defaultProfile",
              defaulMessage: "Default Profile",
            })}
          >
            <Select>
              <Select.Option value={false}>No</Select.Option>
              <Select.Option value={true}>Yes</Select.Option>
            </Select>
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <Typography.Title level={4}>Profile</Typography.Title>
        </Col>
        <Col span={6}>
          <MatchProfileNumberFormInput
            required={true}
            name={"numberOfPeriods"}
            label={formatMessage({
              id: "number.of.periods",
              defaultMessage: "Number Of Periods:",
            })}
          >
            <InputNumber style={{ width: "100%" }} />
          </MatchProfileNumberFormInput>
        </Col>
        <Col span={6}>
          <MatchProfileNumberFormInput
            required={true}
            name={"periodLength"}
            label={formatMessage({
              id: "period.length",
              defaultMessage: "Period Length:",
            })}
          >
            <InputNumber style={{ width: "100%" }} />
          </MatchProfileNumberFormInput>
        </Col>
        <Col span={6}>
          <Form.Item
            name={"overtimeAllowed"}
            label={formatMessage({
              id: "extra.time.allowed",
              defaultMessage: "Is Extra Time Allowed?",
            })}
          >
            <Select>
              <Select.Option value={false}>No</Select.Option>
              <Select.Option value={true}>Yes</Select.Option>
            </Select>
          </Form.Item>
        </Col>
        <Col span={6}>
          <MatchProfileNumberFormInput
            name={"overtimeLength"}
            label={formatMessage({
              id: "extra.time.length",
              defaultMessage: "Extra Time Length (in minutes)",
            })}
          >
            <InputNumber style={{ width: "100%" }} />
          </MatchProfileNumberFormInput>
        </Col>
        <Col span={6}>
          <MatchProfileNumberFormInput
            required={true}
            name={"maximumRosterSize"}
            label={formatMessage({
              id: "maximum.roster.size",
              defaultMessage: "Maximum Roster Size",
            })}
          >
            <InputNumber style={{ width: "100%" }} />
          </MatchProfileNumberFormInput>
        </Col>
        <Col span={6}>
          <MatchProfileNumberFormInput
            name={"periodBreakDuration"}
            label={formatMessage({
              id: "period.break.duration",
              defaultMessage: "Period Break Duration",
            })}
          >
            <InputNumber style={{ width: "100%" }} />
          </MatchProfileNumberFormInput>
        </Col>
        <Col span={6}>
          <MatchProfileNumberFormInput
            required={true}
            name={"halfTimeDuration"}
            label={formatMessage({
              id: "half.time.duration",
              defaultMessage: "Half Time Duration",
            })}
          >
            <InputNumber style={{ width: "100%" }} />
          </MatchProfileNumberFormInput>
        </Col>
        <Col span={6}>
          <MatchProfileNumberFormInput
            required={true}
            name={"maximumPlayersOnCourt"}
            label={formatMessage({
              id: "maximum.players.on.court",
              defaultMessage: "Max players on court per team",
            })}
            rules={[
              ({ getFieldValue }) =>
                createMaxPlayersValidator(getFieldValue, formatMessage, "form.matchProfile.error.maximumPlayersOnCourt"),
            ]}
          >
            <InputNumber style={{ width: "100%" }} />
          </MatchProfileNumberFormInput>
        </Col>
        <Col span={6}>
          <MatchProfileNumberFormInput
            name={"maximumGoalkeeperSubstitutions"}
            label={formatMessage({
              id: "maximum.goalkeeper.substitutions",
              defaultMessage: "Maximum Goalkeeper substitutions per game",
            })}
          >
            <InputNumber style={{ width: "100%" }} />
          </MatchProfileNumberFormInput>
        </Col>
        <Col span={6}>
          <Form.Item
            name={"shootoutIfTie"}
            label={formatMessage({
              id: "shoot.out.if.tie",
              defaultMessage: "Shootout If Tie?",
            })}
          >
            <Select>
              <Select.Option value={false}>No</Select.Option>
              <Select.Option value={true}>Yes</Select.Option>
            </Select>
          </Form.Item>
        </Col>
        <Col span={6}>
          <MatchProfileNumberFormInput
            name={"shotsUntilSuddenDeath"}
            label={formatMessage({
              id: "shots.until.sudden.death",
              defaultMessage: "Shots until sudden death",
            })}
          >
            <InputNumber style={{ width: "100%" }} />
          </MatchProfileNumberFormInput>
        </Col>
        <Col span={6}>
          <MatchProfileNumberFormInput
            name={"timeoutsAllowed"}
            label={formatMessage({
              id: "timeouts.allowed",
              defaultMessage: "Number of match timeouts",
            })}
          >
            <InputNumber style={{ width: "100%" }} />
          </MatchProfileNumberFormInput>
        </Col>
        <Col span={24}>
          <Form.Item
            labelCol={{
              span: 6,
            }}
            wrapperCol={{
              span: 20,
            }}
            name={"typeOfCards"}
            label={formatMessage({
              id: "type.of.cards",
              defaultMessage: "What type of cards allowed in this match?",
            })}
          >
            <Checkbox.Group options={typeOfCards}></Checkbox.Group>
          </Form.Item>
        </Col>
        <Col span={6}>
          <MatchProfileNumberFormInput
            name={"yellowCardSeconds"}
            label={formatMessage({
              id: "yellow.card.minutes",
              defaultMessage: "Yellow card minutes",
            })}
          >
            <InputNumber style={{ width: "100%" }} />
          </MatchProfileNumberFormInput>
        </Col>
        <Col span={6}>
          <MatchProfileNumberFormInput
            name={"redCardSeconds"}
            label={formatMessage({
              id: "red.card.minutes",
              defaultMessage: "Red card minutes",
            })}
          >
            <InputNumber style={{ width: "100%" }} />
          </MatchProfileNumberFormInput>
        </Col>
        <Col span={6}>
          <MatchProfileNumberFormInput
            name={"blueCardSeconds"}
            label={formatMessage({
              id: "blue.card.minutes",
              defaultMessage: "Blue card minutes",
            })}
          >
            <InputNumber style={{ width: "100%" }} />
          </MatchProfileNumberFormInput>
        </Col>
        <Col span={6}>
          <Form.Item
            name={"videoReviewAllowed"}
            label={formatMessage({
              id: "videoReviewAllowed",
              defaulMessage: "Video Review",
            })}
            tooltip={formatMessage({
              id: "videoReviewAllowed",
              defaultMessage: "Is video review allowed?",
            })}
          >
            <Select>
              <Select.Option value={false}>No</Select.Option>
              <Select.Option value={true}>Yes</Select.Option>
            </Select>
          </Form.Item>
        </Col>
        <Col span={24}>
          <Form.Item
            labelCol={{
              span: 6,
            }}
            wrapperCol={{
              span: 20,
            }}
            name={"switchPlayingDirection"}
            label={formatMessage({
              id: "switch.play.direction",
              defaultMessage: "Switch direction of play after period/s:",
            })}
          >
            <Checkbox.Group options={checkboxOptions}></Checkbox.Group>
          </Form.Item>
        </Col>
        <Col span={24}>
          <Form.Item
            labelCol={{
              span: 6,
            }}
            wrapperCol={{
              span: 20,
            }}
            name={"resetTimeoutsAfterPeriods"}
            label={formatMessage({
              id: "reset.timeouts.after.periods",
              defaultMessage: "Reset timeouts after period/s",
            })}
          >
            <Checkbox.Group options={checkboxOptions}></Checkbox.Group>
          </Form.Item>
        </Col>
      </Row>
    </>
  );
};

export default HandballForm;
